import React from 'react'
import {FaGithub, FaLinkedin} from 'react-icons/fa'
function Footer() {

    const handleClickGit = () => {
      window.open("https://github.com/Escobar-Luis");
    }
    const handleClickIn = () => {
      window.open("https://www.linkedin.com/in/luisalfredoescobar/");
    }
  return (
    <div className=" bg-black w-screen flex justify-center shadow-2xl  shadow-rb">
      <div className=" w-1/2">
        <div className="p-3 font-mono text-center">
          <p className="text-white pb-3">Designed & Developed By</p>
          <div className="h-1 border-2 border-white border-dotted"></div>
            <div className="flex  text-white h-[5rem] w-full justify-center py-3 space-x-10">
              <div className="bg-white hover:bg-ph rounded-full hover:cursor-pointer">
          <lottie-player
        
            onClick={handleClickGit}
                src="https://assets5.lottiefiles.com/packages/lf20_dK9q4K.json"
                background="transparent"
                speed="1"
                loop
                autoplay
                name='git'
              ></lottie-player>
              </div>
              <div className="bg-white hover:bg-ph rounded-full hover:cursor-pointer">
          <lottie-player
                onClick={handleClickIn}
                src="https://assets10.lottiefiles.com/packages/lf20_yNYxCH.json"
                background="transparent"
                speed="1"
                loop
                autoplay
                name='git'
              ></lottie-player>
              </div>
            </div>
          <div className="h-1 border-2 border-white border-dotted"></div>
            
          <p className="text-white pt-3">Luis Alfredo Escobar</p>
        </div>
      </div>
    </div>
  )
}

export default Footer